import { render, staticRenderFns } from "./CCopyField.vue?vue&type=template&id=64fe4b26&scoped=true&"
import script from "./CCopyField.vue?vue&type=script&lang=js&"
export * from "./CCopyField.vue?vue&type=script&lang=js&"
import style0 from "./CCopyField.vue?vue&type=style&index=0&id=64fe4b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe4b26",
  null
  
)

export default component.exports